import { Link } from "react-router-dom";

export const PageHero = ({ kicker, title, accent, lead, breadcrumb = [] }) => (
  <section className="container-wide pt-16 md:pt-24 pb-16 md:pb-20 border-b border-ink">
    <div className="flex items-center gap-2 mb-10 font-mono-cust text-[11px] uppercase tracking-[0.25em] text-gray-500">
      <Link to="/" className="hover:text-[#9F381A]">Home</Link>
      {breadcrumb.map((b, i) => (
        <span key={i} className="flex items-center gap-2">
          <span>/</span>
          <span className="text-ink">{b}</span>
        </span>
      ))}
    </div>
    <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A] mb-6">
      {kicker}
    </p>
    <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95] max-w-[18ch]">
      {title} {accent && <em className="font-editorial italic text-[#9F381A]">{accent}</em>}
    </h1>
    {lead && (
      <p className="mt-10 max-w-2xl text-lg md:text-xl text-ink-muted leading-relaxed">{lead}</p>
    )}
  </section>
);

export default PageHero;
